import { initRegisterOptions } from './tool.js'

export const drivingExperience = [
  {
    label: 'None',
    value: 'None'
  },
  {
    label: '1-5 months',
    value: '1-5 Months'
  },
  {
    label: '6-11 months',
    value: '6-11 Months'
  },
  {
    label: '1 year',
    value: '1 Year'
  },
  {
    label: '2 years',
    value: '2 Years'
  },
  {
    label: '3 years',
    value: '3 Years'
  },
  {
    label: '4 years',
    value: '4 Years'
  },
  {
    label: '5+ years',
    value: '5 and more Years'
  }
]

export const licenseClass = [
  {
    label: 'Class A',
    value: 'Class A'
  },
  {
    label: 'Class B',
    value: 'Class B'
  },
  {
    label: 'Class C',
    value: 'Class C'
  }
]

export const driverType = [
  {
    label: 'Company driver',
    value: 'Company driver'
  },
  {
    label: 'Independent O/O',
    value: 'Independent O/O'
  },
  {
    label: 'Dependent O/O',
    value: 'Dependent O/O and planning lease/purchase plan with company'
  },
  {
    label: 'Unavailable Dependent O/O',
    value: 'Dependent O/O but not available'
  },
  {
    label: 'Student',
    value: 'Student'
  },
  {
    label: 'Other',
    value: 'Other'
  }
]

export const freightType = [
  {
    label: 'Dry Van',
    value: 'dryVan'
  },
  {
    label: 'Drybulk',
    value: 'dryBulk'
  },
  {
    label: 'Reefer',
    value: 'reefer'
  },
  {
    label: 'Intermodal',
    value: 'intermodal'
  },
  {
    label: 'Flatbed',
    value: 'flatbed'
  },
  {
    label: 'Tanker',
    value: 'tanker'
  },
  {
    label: 'Car Hauler',
    value: 'carHauler'
  },
  {
    label: 'Overdimensional',
    value: 'overdimensional'
  }
]
export const endorsements = [
  {
    label: 'Hazmat(H)',
    value: 'hazmat'
  },
  {
    label: 'Tank vehicles',
    value: 'tankVehicles'
  },
  {
    label: 'Doubles/Triples',
    value: 'doublesOrTriples'
  },
  {
    label: 'Tanker+Hazmat(X)',
    value: 'tankerAndHazmat'
  },
  {
    label: 'TWIC',
    value: 'twic'
  },
  {
    label: 'Canadian Qualified',
    value: 'canadianQualified'
  },
  {
    label: 'Other',
    value: 'other'
  }
]

export const routeExperience = [
  {
    label: 'Local',
    value: 'local'
  },
  {
    label: 'OTR',
    value: 'otr'
  },
  {
    label: 'Regional',
    value: 'regional'
  },
  {
    label: 'Dedicated',
    value: 'dedicatea'
  },
  {
    label: 'LTL',
    value: 'ltl'
  }
]

export const stateOptions = [
  {
    label: 'Alabama',
    value: 'AL'
  },
  {
    label: 'Alaska',
    value: 'AK'
  },
  {
    label: 'Arizona',
    value: 'AZ'
  },
  {
    label: 'Arkansas',
    value: 'AR'
  },
  {
    label: 'California',
    value: 'CA'
  },
  {
    label: 'Colorado',
    value: 'CO'
  },
  {
    label: 'Connecticut',
    value: 'CT'
  },
  {
    label: 'Delaware',
    value: 'DE'
  },
  {
    label: 'District of Columbia',
    value: 'DC'
  },
  {
    label: 'Florida',
    value: 'FL'
  },
  {
    label: 'Georgia',
    value: 'GA'
  },
  {
    label: 'Hawaii',
    value: 'HI'
  },
  {
    label: 'Idaho',
    value: 'ID'
  },
  {
    label: 'Illinois',
    value: 'IL'
  },
  {
    label: 'Indiana',
    value: 'IN'
  },
  {
    label: 'Iowa',
    value: 'IA'
  },
  {
    label: 'Kansas',
    value: 'KS'
  },
  {
    label: 'Kentucky',
    value: 'KY'
  },
  {
    label: 'Louisiana',
    value: 'LA'
  },
  {
    label: 'Maine',
    value: 'ME'
  },
  {
    label: 'Maryland',
    value: 'MD'
  },
  {
    label: 'Massachusetts',
    value: 'MA'
  },
  {
    label: 'Michigan',
    value: 'MI'
  },
  {
    label: 'Minnesota',
    value: 'MN'
  },
  {
    label: 'Mississippi',
    value: 'MS'
  },
  {
    label: 'Missouri',
    value: 'MO'
  },
  {
    label: 'Montana',
    value: 'MT'
  },
  {
    label: 'Nebraska',
    value: 'NE'
  },
  {
    label: 'Nevada',
    value: 'NV'
  },
  {
    label: 'New Hampshire',
    value: 'NH'
  },
  {
    label: 'New Jersey',
    value: 'NJ'
  },
  {
    label: 'New Mexico',
    value: 'NM'
  },
  {
    label: 'New York',
    value: 'NY'
  },
  {
    label: 'North Carolina',
    value: 'NC'
  },
  {
    label: 'North Dakota',
    value: 'ND'
  },
  {
    label: 'Ohio',
    value: 'OH'
  },
  {
    label: 'Oklahoma',
    value: 'OK'
  },
  {
    label: 'Oregon',
    value: 'OR'
  },
  {
    label: 'Pennsylvania',
    value: 'PA'
  },
  {
    label: 'Rhode Island',
    value: 'RI'
  },
  {
    label: 'South Carolina',
    value: 'SC'
  },
  {
    label: 'South Dakota',
    value: 'SD'
  },
  {
    label: 'Tennessee',
    value: 'TN'
  },
  {
    label: 'Texas',
    value: 'TX'
  },
  {
    label: 'Utah',
    value: 'UT'
  },
  {
    label: 'Vermont',
    value: 'VT'
  },
  {
    label: 'Virginia',
    value: 'VA'
  },
  {
    label: 'Washington',
    value: 'WA'
  },
  {
    label: 'West Virginia',
    value: 'WV'
  },
  {
    label: 'Wisconsin',
    value: 'WI'
  },
  {
    label: 'Wyoming',
    value: 'WY'
  }
]

// freightType/endorsement/routeExperience的初始值

export const freightTypeData = () => initRegisterOptions(freightType)
export const endorsementData = () => initRegisterOptions(endorsements)
export const routeExperienceData = () => initRegisterOptions(routeExperience)

// 注册时需填的个人信息
export const registerForm = () => ({
  birthday: '',
  canEmailed: true,
  city: '',
  country: '',
  state: '',
  street1: '',
  street2: '',
  zip: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  cdlNumber: '',
  cdlState: '',
  cdlClass: '',
  driverType: '',
  drivingExperience: '',
  drivingFriendlyZone: [''],
  freightType: freightTypeData(),
  endorsement: { ...endorsementData(), otherText: '' },
  routeExperience: routeExperienceData(),
  teamDriving: null,
  accdntsFiveYrs: null,
  violationsFiveYrs: null,
  licnsSupendFiveYrs: null,
  duiOrDWIConFiveYrs: null,
  driverLandingPageAnswers: [],
  source: '',
  employmentHistory: [],
  campaignId: ''
})
